import React, { useState } from 'react'
import { useSearchParams, useNavigate  } from 'react-router-dom'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { Box, Button } from '@mui/material'
import GroupStudents from './GroupStudents'
import GroupSubjects from './GroupSubjects'

const styles = {
    orderButton: {
        display: 'flex',
        color: '#4F72EA',
        alignItems: 'center',
        cursor: 'pointer',
        mr: 2,
    },
    flex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
}

const GroupDetailsPage = () => {
    const { formatMessage } = useIntl()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams('')
    const [showStudents, setShowStudents] = useState(
        searchParams.get('group') === 'subjects' ? false : true,
    )

    const setParams = (groupParam) => {
        const params = {
            course: searchParams.get('course'),
            group: groupParam,
            groupName: searchParams.get('groupName'),
        }
        setSearchParams(params)
    }

    return (
        <Wrapper>
            <Box
                sx={styles.flex}
                mb={2}
            >
                <Button 
                    variant="contained" 
                    onClick={() => navigate('/groups')}
                >
                    {formatMessage({id: "back"})}
                </Button>
                
                <Tabs>
                    <Tab
                        searchParams={searchParams.get('group')}
                        group="students"
                        onClick={() => {
                            setParams('students')
                            setShowStudents(true)
                        }}
                    >
                        {formatMessage({ id: 'students' })}
                    </Tab>

                    <Tab
                        searchParams={searchParams.get('group')}
                        group="subjects"
                        onClick={() => {
                            setParams('subjects')
                            setShowStudents(false)
                        }}
                    >
                        {formatMessage({ id: 'subjects' })}
                    </Tab>
                </Tabs>
            </Box>

            {showStudents ? (
                <GroupStudents queryParams={searchParams} />
            ) : (
                <GroupSubjects
                    courseId={Number(searchParams.get('course'))}
                    groupName={searchParams.get('groupName')}
                />
            )}
        </Wrapper>
    )
}

export default GroupDetailsPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Tabs = styled.div`
    display: flex;
    background: #e4e5e7;
    height: 24px;
    padding: 4px;
    border-radius: 8px;
    align-items: center;
    cursor: pointer;
`

const Tab = styled.div<{ searchParams: string; group: string }>`
    background: ${(props) =>
        props.group == 'students' && props.searchParams == null
            ? '#FFFFFF'
            : props.searchParams == props.group
            ? '#FFFFFF'
            : '#E4E5E7'};
    border-radius: 5px;
    padding: 4px 20px;
    color: ${(props) =>
        props.group == 'students' && props.searchParams == null
            ? '#404A51'
            : props.searchParams == props.group
            ? '#404A51'
            : '#AABBC7'}; ;
`
